export const translations = {
  'en-US': {
    common: {
      loading: 'Loading...',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      close: 'Close',
      apply: 'Apply',
      clear: 'Clear',
      search: 'Search',
      filter: 'Filter',
      all: 'All',
      yes: 'Yes',
      no: 'No',
      send: 'Send',
      back: 'Back',
      next: 'Next',
      submit: 'Submit',
      continue: 'Continue',
      learnMore: 'Learn More',
      getStarted: 'Get Started'
    },
    nav: {
      feed: 'Feed',
      matches: 'Matches',
      messages: 'Messages',
      notifications: 'Notifications',
      profile: 'Profile',
      dashboard: 'Dashboard',
      candidates: 'Candidates',
      settings: 'Settings',
      features: 'Features',
      howItWorks: 'How It Works',
      about: 'About',
      forCompanies: 'For Companies',
      forCandidates: 'For Candidates'
    },
    hero: {
      badge: 'Anonymous Professional Networking',
      title: 'Your Next Career Move,',
      titleLine2: 'Without Revealing Your Identity',
      description: 'Connect with exceptional opportunities from direct employers while maintaining complete anonymity. Access premium curated roles for senior professionals.',
      requestAccess: 'Request Access',
      learnMore: 'Learn More',
      feature1: '100% Anonymous',
      feature2: '8+ Years Experience',
      feature3: 'Direct Employers Only'
    },
    accessRequest: {
      title: 'Choose Your Role',
      subtitle: 'Select how you want to use BlinD',
      qualificationTitle: 'Qualification',
      qualificationSubtitle: 'Tell us about your professional background',
      fullName: 'Full Name',
      email: 'Email Address',
      experience: 'Years of Experience',
      industry: 'Industry',
      seniority: 'Seniority Level',
      language: 'Language Preference',
      location: 'Location',
      linkedinUrl: 'LinkedIn Profile',
      confirmExperience: 'I confirm that I have 8+ years of professional experience at a senior level',
      confirmDiscretion: 'I understand that my identity will remain anonymous until I choose to reveal it',
      candidateTitle: 'I\'m a Senior Professional',
      candidateDesc: 'Looking for my next career opportunity',
      candidateReq1: '8+ years of professional experience',
      candidateReq2: 'Senior-level or executive position',
      candidateReq3: 'Currently employed or recently transitioned',
      employerTitle: 'I\'m an Employer',
      employerDesc: 'Looking to hire senior talent',
      employerReq1: 'Direct hiring authority',
      employerReq2: 'Not a recruitment agency',
      employerReq3: 'Hiring senior-level positions',
      applicationReceived: 'Application Received',
      reviewProcess: 'Review Process',
      reviewProcessDesc: 'Our team will review your application within 2-3 business days',
      nextSteps: 'Next Steps',
      nextStepsDesc: 'If approved, you\'ll receive access credentials via email',
      questions: 'Questions?',
      questionsDesc: 'Contact us at',
      returnHome: 'Return to Home',
      successTitle: 'Thank You for Your Application!',
      successSubtitle: 'We\'ve received your request and will review it shortly.',
      successCandidateMessage: 'As a candidate, you\'ll gain access to exclusive opportunities from verified employers once approved.',
      successEmployerMessage: 'As an employer, you\'ll be able to access our curated pool of senior professionals once verified.'
    },
    termsOfService: {
      stepLabel: 'Terms of Service',
      title: 'Terms of Service Agreement',
      subtitle: 'Please read and agree to the following terms before proceeding',
      feeStructureTitle: 'Platform Fee Structure',
      feeStructureDesc: 'By using the BlinD platform to hire candidates, you agree that all successful hires made through this platform are subject to a placement fee. This fee ensures the quality and sustainability of our service.',
      feeHighlight: '20% placement fee applies to all hires made through the BlinD platform, calculated on the candidate\'s first-year annual salary.',
      antiCircumventionTitle: 'Anti-Circumvention Policy',
      antiCircumventionDesc: 'To maintain fairness and platform integrity, you agree not to circumvent the platform by hiring candidates outside of BlinD after being introduced through our service. This includes:',
      antiCircumventionPoint1: 'Contacting candidates directly outside the platform to avoid fees',
      antiCircumventionPoint2: 'Hiring candidates through other channels after initial introduction via BlinD',
      antiCircumventionPoint3: 'Sharing candidate information with third parties to facilitate off-platform hiring',
      antiCircumventionWarning: 'Violation of this policy may result in immediate account termination and legal action to recover fees.',
      paymentTermsTitle: 'Payment Terms',
      paymentTermsDesc: 'The 20% placement fee is due within 30 days of the candidate\'s start date. Payment must be made via the methods specified in your employer agreement. Late payments may incur additional fees and account suspension.',
      complianceTitle: 'Compliance and Audit Rights',
      complianceDesc: 'BlinD reserves the right to audit hiring activities to ensure compliance with these terms. You agree to provide reasonable documentation upon request to verify that all hires introduced through BlinD are properly reported and fees paid.',
      agreeFeeStructure: 'I understand and agree to the 20% placement fee structure for all hires made through BlinD',
      agreeAntiCircumvention: 'I understand and agree not to circumvent the platform by hiring candidates outside of BlinD after introduction',
      agreePaymentTerms: 'I understand and agree to the payment terms, including the 30-day payment deadline',
      agreeCompliance: 'I understand and agree to BlinD\'s audit rights and will provide documentation as needed',
      finalAcknowledgment: 'By checking all boxes above, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service. Violation of these terms may result in account termination and legal consequences.'
    },
    onboarding: {
      languageTitle: 'Select Your Preferred Language',
      languageSubtitle: 'Choose the language for your BlinD experience',
      english: 'English',
      englishDesc: 'All content in English',
      french: 'Français',
      frenchDesc: 'Tout le contenu en français',
      bilingual: 'Bilingual',
      bilingualDesc: 'Content in both languages',
      locationTitle: 'Where Are You Located?',
      locationSubtitle: 'This helps us show you relevant opportunities in your region',
      country: 'Country/Region',
      province: 'Province',
      state: 'State',
      selectProvince: 'Select your province',
      selectState: 'Select your state'
    },
    opportunityFeed: {
      title: 'Opportunity Feed',
      newToday: 'New Today',
      totalMatches: 'Total Matches',
      exceptionalOnly: 'Exceptional Only',
      location: 'Location',
      industry: 'Industry',
      roleType: 'Role Type',
      analyzing: 'Analyzing opportunity...',
      pass: 'Pass',
      interested: 'Interested',
      itsAMatch: "It\'s a Match!",
      matchMessage: 'The employer is also interested in your profile. You can now start a conversation.',
      viewMatches: 'View Matches',
      keepExploring: 'Keep Exploring',
      noOpportunities: 'No More Opportunities',
      noOpportunitiesMessage: 'Check back later for new opportunities that match your profile.',
      adjustFilters: 'Adjust Filters',
      savedFilters: 'Saved Filters',
      searchHistory: 'Search History'
    },
    matchManagement: {
      title: 'Match Management',
      totalMatches: 'Total Matches',
      activeConversations: 'Active Conversations',
      pendingReveals: 'Pending Reveals',
      scheduledMeetings: 'Scheduled Meetings',
      filterByStatus: 'Filter by Status',
      searchMatches: 'Search matches...',
      message: 'Message',
      requestReveal: 'Request Reveal',
      scheduleMeeting: 'Schedule Meeting',
      archive: 'Archive',
      noMatches: 'No Matches Yet',
      noMatchesMessage: 'Start exploring opportunities to find your perfect match.',
      exploreOpportunities: 'Explore Opportunities',
      bulkActions: 'Bulk Actions'
    },
    filters: {
      saveFilter: 'Save Filter',
      filterName: 'Filter Name',
      savedFilters: 'Saved Filters',
      noSavedFilters: 'No saved filters yet',
      searchHistory: 'Search History',
      recentSearches: 'Recent Searches',
      clearHistory: 'Clear History',
      noSearchHistory: 'No search history'
    },
    preview: {
      title: 'Senior Professionals Gallery',
      subtitle: 'Preview anonymous profiles of exceptional senior talent',
      searchPlaceholder: 'Search by role, skills, or industry...',
      allRoles: 'All Roles',
      allIndustries: 'All Industries',
      viewProfile: 'View Full Profile',
      requestAccess: 'Request Access to Connect',
      badge: 'Senior Talent Pool - 8+ Years Experience',
      mainTitle: 'Meet Our Anonymous Senior Professionals',
      mainSubtitle: 'Preview the caliber of senior talent with 8+ years of experience available on BlinD. From C-suite executives to project directors and senior managers - all profiles are anonymous to protect candidate privacy while showcasing their expertise.',
      ctaTitle: 'Ready to Access This Talent Pool?',
      ctaSubtitle: 'Join BlinD to connect with these exceptional senior professionals and discover many more qualified candidates with 8+ years of experience across all industries and roles.',
      ctaButton: 'Request Employer Access',
      filterByRole: 'Filter by Role',
      filterByIndustry: 'Filter by Industry',
      experience: 'Experience',
      industries: 'Industries',
      professionalProfile: 'Professional Profile',
      keySkills: 'Key Skills',
      keyAchievements: 'Key Achievements',
      more: 'more',
      availableOnMarket: 'Available on Market',
      openToOpportunities: 'Open to Opportunities',
      showLess: 'Show Less',
      viewDetails: 'View Details',
      cSuiteExecutives: 'C-Suite Executives',
      avgYearsExperience: 'Avg Years Experience',
      avgMatchScore: 'Avg Match Score',
      identityProtected: 'Identity Protected'
    },
    features: {
      title: 'Why Choose BlinD?',
      subtitle: 'A collaborative platform designed for senior professionals and forward-thinking employers',
      anonymity: 'Complete Anonymity',
      anonymityDesc: 'Your identity remains protected throughout the entire process. Explore opportunities without risk to your current position.',
      exclusiveNetwork: 'Exclusive Curated Network',
      exclusiveNetworkDesc: 'Access to verified senior professionals with 8+ years of experience across all industries, carefully curated by Groupe JM experts.',
      directEmployers: 'Direct Connections',
      directEmployersDesc: 'Connect directly with companies through our platform. Real opportunities from real decision makers.',
      hiddenMarket: 'Access to Hidden Market',
      hiddenMarketDesc: 'Discover unannounced opportunities and exclusive opportunities through our curated network.',
      verifiedProfiles: 'Verified Profiles',
      verifiedProfilesDesc: 'Each candidate goes through a rigorous verification process to ensure quality and relevance.',
      smartMatching: 'Intelligent Matching',
      smartMatchingDesc: 'AI-powered matching connects you with opportunities that truly align with your experience and career goals.'
    },
    hiddenMarketSection: {
      mainStat: '80%',
      mainTitle: 'Hidden Market Opportunities for Senior Profiles',
      mainSubtitle: 'The hidden market represents the majority of quality opportunities that are never publicly posted.',
      forCompanies: 'For Companies',
      companiesTitle: 'Direct Access to Verified Senior Talent',
      companiesDesc: 'Connect directly with experienced professionals across all sectors and roles through our exclusive curated network.',
      companiesBenefit1: 'All roles in all sectors (8+ years experience)',
      companiesBenefit2: 'Access to passive senior talent curated by Groupe JM experts',
      companiesBenefit3: 'Verified profiles only - quality assured by our team',
      companiesBenefit4: 'Confidential publish jobs without alerting internal teams',
      whyDifferent: 'Why BlinD is Different:',
      exclusiveNetworkTitle: 'Exclusive Curated Network',
      exclusiveNetworkDesc: 'Carefully selected senior professionals verified by Groupe JM',
      rigorousVerification: 'Rigorous Verification',
      rigorousVerificationDesc: 'Each candidate goes through verification to ensure quality and relevance',
      directPassiveTalent: 'Access to Passive Talent',
      directPassiveTalentDesc: 'Atteignez les meilleurs performeurs qui ne cherchent pas activement d\'emploi',
      viewSeniorProfessionals: 'View Senior Professionals',
      forCandidates: 'For Candidates',
      candidatesTitle: 'Explore Opportunities Safely',
      candidatesDesc: 'Access exclusive hidden market opportunities while maintaining complete anonymity. Perfect for experienced professionals exploring their next step.',
      candidatesBenefit1: 'Opportunities in all sectors for senior professionals with 8+ years experience',
      candidatesBenefit2: 'Direct access to companies through our platform',
      candidatesBenefit3: 'Passively explore while employed - nobody will ever know',
      candidatesBenefit4: 'Control when and to whom you reveal your identity',
      yourAdvantages: 'Your Advantages:',
      anonymousExploration: '100% Anonymous Exploration',
      anonymousExplorationDesc: 'Explore opportunities without alerting your current employer or team',
      accessHiddenMarket: 'Access Hidden Market',
      accessHiddenMarketDesc: '80% of quality opportunities are never publicly posted - access them here',
      completeConfidentiality: 'Complete Confidentiality',
      completeConfidentialityDesc: 'No public profiles, no LinkedIn activity, no risk to your current position'
    },
    problem: {
      title: 'Challenges in Senior Career Transitions',
      subtitle: 'Senior professionals face unique challenges when exploring new opportunities.',
      recruiterSpam: 'Privacy Protection',
      recruiterSpamDesc: 'Maintaining confidentiality while exploring opportunities is essential for senior professionals who need discretion.',
      privacyConcerns: 'Confidential Exploration',
      privacyConcernsDesc: 'The ability to explore opportunities without alerting your current employer is crucial for career planning.',
      timeWasted: 'Efficient Process',
      timeWastedDesc: 'Senior professionals need streamlined processes that respect their time and match their expertise level.',
      cvFatigue: 'Curated Matching',
      cvFatigueDesc: 'Access to pre-qualified opportunities that match your experience and career goals saves valuable time.'
    },
    solution: {
      badge: 'The BlinD Solution',
      title: 'Professional Networking, Re-imagined',
      subtitle: 'A premium platform designed exclusively for senior professionals seeking discretion and quality.',
      completeAnonymity: 'Complete Anonymity',
      completeAnonymityDesc: 'Your identity remains hidden until you choose to reveal it. No names, no photos, no company details.',
      curatedOpportunities: 'Curated Opportunities',
      curatedOpportunitiesDesc: 'Verified senior-level opportunities from direct employers, curated by Groupe JM experts.',
      smartMatching: 'Intelligent Matching',
      smartMatchingDesc: 'AI-powered matching highlights your expertise without revealing who you are. Browse opportunities that match your criteria.',
      controlReveals: 'You Control Your Reveals',
      controlRevealsDesc: 'Decide when to reveal your identity. Each reveal requires explicit consent and administrative approval for security.'
    },
    talent: {
      badge: 'For Talents',
      title: 'Your Career, Your Terms',
      subtitle: 'You\'ve built 8+ years of expertise. You deserve opportunities that match your caliber, presented with the discretion you require.',
      stayAnonymous: 'Stay Anonymous',
      stayAnonymousDesc: 'Browse opportunities without your current employer knowing',
      premiumRoles: 'Premium Roles',
      premiumRolesDesc: 'Access to non-publicly announced senior-level roles',
      directContact: 'Direct Contact',
      directContactDesc: 'Connect directly with hiring managers, bypass recruiters',
      youDecide: 'You Decide',
      youDecideDesc: 'Control when and to whom you reveal your identity',
      requestTalentAccess: 'Request Talent Access',
      identityProtected: 'Identity Protected'
    },
    employer: {
      badge: 'For Employers',
      title: 'Hire Senior Leadership',
      titleLine2: 'Discreetly and Efficiently',
      subtitle: 'Access a curated pool of top senior executives and directors with 8+ years of experience. See exactly what matters: titles, skills, and expertise—without the noise.',
      executiveCandidatePool: 'Senior Executive Pool',
      matches: 'Matches',
      experience: 'Experience',
      whyBlinDBetter: 'Why BlinD Adds Value',
      headhunters: 'Traditional Methods',
      headhuntersProblem: 'Limited reach',
      headhuntersSolution: 'Expanded talent pool',
      jobBoards: 'Public Job Sites',
      jobBoardsProblem: 'Broad candidate pool',
      jobBoardsSolution: 'Curated senior professionals',
      linkedinRecruiter: 'Direct Outreach',
      linkedinProblem: 'Time-intensive process',
      linkedinSolution: 'Mutual interest matching',
      passiveTalent: 'Passive Talent',
      passiveTalentDesc: 'Access senior professionals who aren\'t actively seeking but open to the right opportunity',
      structuredProfiles: 'Structured Profiles',
      structuredProfilesDesc: 'AI-generated profiles revealing expertise without traditional CVs',
      fastMatching: 'Fast Matching',
      fastMatchingDesc: 'Scalable interface for efficient candidate review',
      directHiring: 'Direct Connections',
      directHiringDesc: 'Streamlined connections through our platform',
      requestEmployerAccess: 'Request Employer Access',
      previewWhat: 'Preview What Employers See'
    },
    howItWorks: {
      badge: 'Simple Process',
      title: 'How BlinD Works',
      subtitle: 'From anonymous profile to successful match in four simple steps.',
      step1Title: 'Request Access',
      step1Desc: 'Submit your application with basic qualifications. We manually review each application to ensure quality.',
      step2Title: 'Create Anonymous Profile',
      step2Desc: 'Respond to industry-specific questions. Our AI generates a convincing profile that highlights your expertise without revealing your identity.',
      step3Title: 'Browse and Match',
      step3Desc: 'Browse opportunities or curated candidates. When both parties express interest, it\'s a match.',
      step4Title: 'Controlled Reveal',
      step4Desc: 'Decide when to reveal your identity. Each reveal requires explicit consent and administrative approval for security.'
    },
    about: {
      title: 'Our Story',
      subtitle: 'Building the Future of Senior Recruitment',
      originsTitle: 'Our Origins',
      originsDesc: 'Groupe JM has been connecting companies with top talent for years. Through this experience, we identified an opportunity to better serve senior professionals and employers.',
      breakingPointTitle: 'Our Vision',
      breakingPointDesc1: 'We recognized that senior professionals need a platform that prioritizes anonymity and discretion while employers need access to qualified passive talent.',
      breakingPointDesc2: 'We asked ourselves: How can we create a complementary solution that enriches the recruitment ecosystem?',
      missionTitle: 'Our Mission Today',
      missionDesc1: 'BlinD was created to complement existing recruitment approaches with an exclusive, curated network of senior professionals.',
      missionDesc2: 'We partner with employers, professionals, and industry stakeholders to foster anonymous, diverse connections for all senior roles.',
      forCandidatesTitle: 'For Candidates',
      forCandidatesDesc: 'Explore opportunities with complete anonymity and control over your career journey',
      forCompaniesTitle: 'For Companies',
      forCompaniesDesc: 'Access exclusive senior talent through our curated network and streamlined platform',
      ourPromiseTitle: 'Our Promise',
      ourPromiseDesc: 'Meaningful connections that complement your existing strategies and drive real growth'
    },
    trust: {
      badge: 'Confidence & Security',
      title: 'Your Confidentiality is Our Priority',
      subtitle: 'Enterprise-level security and compliance to protect your professional identity.',
      dataProtection: 'Data Protection',
      dataProtectionDesc: 'Total compliance with Canadian and American data protection regulations',
      encryptedCommunication: 'Encrypted Communication',
      encryptedCommunicationDesc: 'End-to-end encryption for all messages and profile data',
      manualReview: 'Manual Review',
      manualReviewDesc: 'Every identity reveal is manually approved by our team',
      certifiedCompliant: 'Certified & Compliant',
      soc2: 'SOC 2 Type II',
      gdpr: 'GDPR Compliant',
      iso: 'ISO 27001',
      pipeda: 'LPRPDE Certified'
    },
    contact: {
      badge: 'Contact Us',
      title: 'Get In Touch',
      subtitle: 'You have questions? We\'re here to help. Contact our team.',
      emailUs: 'Email Us',
      emailDesc: 'contact@blindrecruit.com',
      liveChat: 'Live Chat',
      liveChatDesc: 'Available Mon-Fri, 9h-17h HNE',
      callUs: 'Call Us',
      callUsDesc: '514-562-6813',
      yourName: 'Your Name',
      emailAddress: 'Email Address',
      subject: 'Subject',
      subjectPlaceholder: 'How can we help you?',
      message: 'Message',
      messagePlaceholder: 'Tell us about your request...',
      sendMessage: 'Send Message',
      successMessage: 'Thank you for contacting us! We will respond within 24 hours.'
    },
    footer: {
      tagline: 'Anonymous Professional Networking for Senior Talents and Direct Employers by Groupe JM. Your Next Career Move, Without Revealing Your Identity.',
      product: 'Product',
      company: 'Company',
      legal: 'Legal',
      features: 'Features',
      howItWorks: 'How It Works',
      forTalent: 'For Talent',
      forEmployers: 'For Employers',
      aboutUs: 'About Us',
      contact: 'Contact',
      careers: 'Careers',
      blog: 'Blog',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      cookiePolicy: 'Cookie Policy',
      dataProtection: 'Data Protection',
      allRightsReserved: 'BlinD. All rights reserved.',
      location: 'Canada & United States',
      compliant: 'GDPR & PIPEDA Compliant'
    },
    profiles: {
      titles: {
        ceo: 'Chief Executive Officer',
        cfo: 'Chief Financial Officer',
        itDirector: 'IT Director',
        projectDirector: 'Project Director',
        seniorDeveloper: 'Senior Software Developer',
        chiefAccountant: 'Chief Accountant',
        hrDirector: 'HR Director',
        realEstateDirector: 'Real Estate Director',
        vpConstruction: 'VP Construction'
      },
      industries: {
        technology: 'Technology',
        saas: 'SaaS',
        finance: 'Finance',
        fintech: 'FinTech',
        healthcare: 'Healthcare',
        construction: 'Construction',
        realEstate: 'Real Estate',
        ecommerce: 'E-commerce',
        manufacturing: 'Manufacturing',
        humanResources: 'Human Resources',
        investment: 'Investment',
        infrastructure: 'Infrastructure'
      },
      skills: {
        strategicPlanning: 'Strategic Planning',
        plManagement: 'P&L Management',
        boardRelations: 'Board Relations',
        ma: 'M&A',
        fundraising: 'Fundraising',
        financialStrategy: 'Financial Strategy',
        ipoExperience: 'IPO Experience',
        riskManagement: 'Risk Management',
        fpa: 'FP&A',
        treasury: 'Treasury',
        itInfrastructure: 'IT Infrastructure',
        cybersecurity: 'Cybersecurity',
        cloudMigration: 'Cloud Migration',
        teamLeadership: 'Team Leadership',
        vendorManagement: 'Vendor Management',
        projectManagement: 'Project Management',
        budgetControl: 'Budget Control',
        stakeholderManagement: 'Stakeholder Management',
        riskMitigation: 'Risk Mitigation',
        qualityAssurance: 'Quality Assurance',
        fullStackDevelopment: 'Full-Stack Development',
        systemArchitecture: 'System Architecture',
        codeReview: 'Code Review',
        mentoring: 'Mentoring',
        agileScrum: 'Agile/Scrum',
        financialReporting: 'Financial Reporting',
        ifrsGaap: 'IFRS/GAAP',
        auditManagement: 'Audit Management',
        taxCompliance: 'Tax Compliance',
        erpSystems: 'ERP Systems',
        talentAcquisition: 'Talent Acquisition',
        organizationalDevelopment: 'Organizational Development',
        employeeRelations: 'Employee Relations',
        compensationStrategy: 'Compensation Strategy',
        changeManagement: 'Change Management',
        portfolioManagement: 'Portfolio Management',
        assetValuation: 'Asset Valuation',
        leaseNegotiation: 'Lease Negotiation',
        marketAnalysis: 'Market Analysis',
        investmentStrategy: 'Investment Strategy',
        constructionManagement: 'Construction Management',
        safetyCompliance: 'Safety Compliance',
        contractNegotiation: 'Contract Negotiation',
        costEstimation: 'Cost Estimation'
      },
      achievements: {
        ceo1: 'Scaled company from $5M to $50M ARR',
        ceo2: 'Led successful Series B ($30M)',
        ceo3: 'Built team from 20 to 200+',
        cfo1: 'Led IPO process ($500M valuation)',
        cfo2: 'Reduced costs by 30%',
        cfo3: 'Implemented financial controls',
        it1: 'Migrated enterprise systems to cloud (99.9% uptime)',
        it2: 'Reduced IT costs by 35%',
        it3: 'Led team of 25+ IT professionals',
        project1: 'Delivered $200M+ projects on time',
        project2: 'Managed 15+ concurrent projects',
        project3: 'Achieved 98% client satisfaction rate',
        dev1: 'Architected platform serving 5M+ users',
        dev2: 'Reduced page load time by 60%',
        dev3: 'Mentored 10+ junior developers',
        accountant1: 'Streamlined month-end close by 40%',
        accountant2: 'Led successful external audits (clean opinions)',
        accountant3: 'Implemented automated reporting systems',
        hr1: 'Reduced turnover by 45%',
        hr2: 'Built HR function from ground up',
        hr3: 'Implemented performance management system',
        realEstate1: 'Managed $500M+ real estate portfolio',
        realEstate2: 'Negotiated deals saving $10M+ annually',
        realEstate3: 'Achieved 15% average ROI',
        construction1: 'Oversaw $1B+ in construction projects',
        construction2: 'Maintained zero safety incidents record',
        construction3: 'Led teams of 100+ workers'
      },
      descriptions: {
        ceo: 'Visionary leader with proven track record in scaling technology companies. Expert in navigating complex board dynamics and securing strategic funding. Known for building high-performing teams and driving sustainable growth through data-driven decision making.',
        cfo: 'Strategic finance executive with deep expertise in capital markets and public company operations. Successfully navigated multiple funding rounds and IPO process. Skilled at building robust financial infrastructure while maintaining operational efficiency.',
        itDirector: 'Results-oriented IT leader specializing in digital transformation and infrastructure modernization. Expert in balancing security requirements with business agility. Proven ability to manage complex vendor relationships and deliver projects on time and under budget.',
        projectDirector: 'Accomplished project leader with extensive experience managing large-scale initiatives from conception to completion. Expert in coordinating cross-functional teams and maintaining strict budget controls. Known for exceptional stakeholder communication and proactive risk management.',
        seniorDeveloper: 'Highly skilled technical professional with deep expertise in building scalable web applications. Strong advocate for clean code and best practices. Passionate about mentoring junior developers and fostering collaborative engineering culture.',
        chiefAccountant: 'Detail-oriented accounting professional with comprehensive knowledge of financial regulations and reporting standards. Expert in managing complex audits and ensuring regulatory compliance. Skilled at leveraging technology to improve accounting processes and accuracy.',
        hrDirector: 'Strategic HR leader focused on building people-first cultures that drive business results. Expert in designing compensation structures and talent development programs. Proven track record in managing organizational change and fostering employee engagement.',
        realEstateDirector: 'Seasoned real estate professional with extensive experience in commercial and residential property management. Expert in identifying high-value investment opportunities and negotiating favorable terms. Strong analytical skills with deep understanding of market dynamics.',
        vpConstruction: 'Experienced construction executive with comprehensive knowledge of building codes, safety regulations, and project delivery methods. Expert in managing large-scale construction operations and ensuring quality standards. Strong leadership skills with focus on safety culture and operational excellence.'
      },
      availability: {
        openToOpportunities: 'Open to opportunities',
        selective: 'Selective'
      },
      companyScale: {
        employees200Plus: '200+ employees',
        employees500Plus: '500+ employees',
        employees300to500: '300-500 employees',
        employees150to200: '150-200 employees',
        employees100to150: '100-150 employees',
        employees250to300: '250-300 employees',
        employees400Plus: '400+ employees',
        employees50to100: '50-100 employees'
      }
    },
    profileCarousel: {
      sectionTitle: 'Discover Exceptional Talent',
      sectionSubtitle: 'Explore profiles of senior professionals with verified experience',
      verifiedBadge: 'All profiles are verified and anonymized',
      aiMatching: 'AI Matching',
      keySkills: 'Key Skills',
      achievements: 'Achievements',
      availableOnMarket: 'Available on Market',
      openToOpportunities: 'Open to New Opportunities',
      experience: 'Experience',
      employees: 'employees',
      profiles: {
        cfo: {
          title: 'Chief Financial Officer',
          experience: '12+ Experience',
          teamSize: '500+ employees',
          industries: ['Finance', 'FinTech'],
          description: 'Strategic finance executive with deep expertise in capital markets and public company operations. Successfully navigated multiple funding rounds and IPO process.',
          skills: ['Financial Strategy', 'IPO Experience', 'Risk Management', 'FP&A', 'Treasury'],
          achievements: [
            'Led IPO process ($500M valuation)',
            'Reduced costs by 30%',
            'Implemented financial controls'
          ]
        },
        vpConstruction: {
          title: 'VP Construction',
          experience: '16+ Experience',
          teamSize: '500+ employees',
          industries: ['Construction', 'Infrastructure'],
          description: 'Experienced construction executive with comprehensive knowledge of building codes, safety regulations, and project delivery methods. Expert in managing large-scale construction operations.',
          skills: ['Construction Management', 'Safety Compliance', 'Contract Negotiation', 'Team Leadership', 'Cost Estimation'],
          achievements: [
            'Oversaw $1B+ in construction projects',
            'Maintained zero safety incidents record',
            'Led teams of 100+ workers'
          ]
        },
        itDirector: {
          title: 'IT Director',
          experience: '10+ Experience',
          teamSize: '300-500 employees',
          industries: ['Technology', 'Healthcare'],
          description: 'Results-oriented IT leader specializing in digital transformation and infrastructure modernization. Expert in balancing security requirements with business agility.',
          skills: ['IT Infrastructure', 'Cybersecurity', 'Cloud Migration', 'Team Leadership', 'Vendor Management'],
          achievements: [
            'Migrated enterprise systems to cloud (99.9% uptime)',
            'Reduced IT costs by 35%',
            'Led team of 25+ IT professionals'
          ]
        }
      }
    },
    collaborativePhilosophy: {
      badge: 'Our Collaborative Philosophy',
      title: 'Enriching the Recruitment Ecosystem',
      subtitle: 'At BlinD and Groupe JM, we believe in a collaborative recruitment ecosystem',
      description: 'An exclusive network curated by our experts that complements existing methods. In partnership with employers, professionals, and industry stakeholders, we foster anonymous, diverse connections for all senior roles.',
      principle1Title: 'Complementary Approach',
      principle1Desc: 'BlinD enriches your existing recruitment strategies rather than replacing them. We provide an additional channel to access passive senior talent.',
      principle2Title: 'Expert Curation',
      principle2Desc: 'Every profile is carefully verified and curated by Groupe JM experts to ensure quality and relevance for senior-level positions.',
      principle3Title: 'Partnership Focus',
      principle3Desc: 'We work collaboratively with employers and professionals to create optimal matches that benefit everyone in the ecosystem.',
      principle4Title: 'Inclusive Excellence',
      principle4Desc: 'Our platform promotes diversity and inclusion while maintaining the highest standards for senior professional experience.'
    },
    complementarity: {
      badge: 'Complementarity & Partnerships',
      title: 'How BlinD Complements Your Process',
      subtitle: 'BlinD by Groupe JM integrates seamlessly with your existing recruitment strategies',
      forEmployers: 'For Employers',
      employerBenefit1Title: 'Additional Talent Channel',
      employerBenefit1Desc: 'Free access to a curated pool of passive senior professionals that complements your existing recruitment methods',
      employerBenefit2Title: 'Harmonious Integration',
      employerBenefit2Desc: 'Works alongside your current tools and strategies without disrupting established processes',
      employerBenefit3Title: 'Expert Partnership',
      employerBenefit3Desc: 'Collaborate with Groupe JM for optimal matches while maintaining your existing recruitment relationships',
      forCandidates: 'For Candidates',
      candidateBenefit1Title: 'Complementary Exploration',
      candidateBenefit1Desc: 'Explore opportunities anonymously while maintaining all your existing professional relationships and networks',
      candidateBenefit2Title: 'Curated Opportunities',
      candidateBenefit2Desc: 'Access to exclusive opportunities curated by Groupe JM experts that complement public job markets',
      candidateBenefit3Title: 'Full Control',
      candidateBenefit3Desc: 'You decide when and how to engage, with complete anonymity until you choose to reveal your identity'
    },
    legal: {
      badge: 'Legal Information',
      title: 'Legal & Compliance',
      subtitle: 'Our commitment to transparency, privacy, and legal compliance',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      cookiePolicy: 'Cookie Policy',
      dataProtection: 'Data Protection',
      lastUpdated: 'Last updated: January 15, 2026',
      privacySection1Title: 'Information We Collect',
      privacySection1Desc: 'BlinD collects minimal personal information necessary to provide our anonymous professional networking service. We collect professional background data, anonymized career information, and communication preferences. All data is encrypted and stored securely in compliance with GDPR, PIPEDA, and Loi 25 regulations.',
      privacySection2Title: 'How We Use Your Information',
      privacySection2Desc: 'Your information is used exclusively to facilitate anonymous job matching between senior professionals and direct employers. We use AI-powered algorithms to match profiles without revealing identities. Your data is never sold to third parties or used for purposes beyond our core service.',
      privacySection3Title: 'Data Security & Anonymity',
      privacySection3Desc: 'We employ industry-leading encryption and security measures to protect your identity. All profiles are anonymized before being shown to employers. Personal identifying information is stored separately from professional profiles and only revealed with your explicit consent after a mutual match.',
      privacySection4Title: 'Your Rights & Control',
      privacySection4Desc: 'You have complete control over your data. You can access, modify, or delete your information at any time. You control when and to whom you reveal your identity. We comply with all data subject rights under GDPR, PIPEDA, and Loi 25, including the right to be forgotten.',
      termsSection1Title: 'Platform Access & Eligibility',
      termsSection1Desc: 'BlinD is available to senior professionals with 8+ years of experience and direct hiring companies. Recruitment agencies and intermediaries are not permitted. Access is granted through a verification process to ensure platform integrity and user safety.',
      termsSection2Title: 'User Conduct & Responsibilities',
      termsSection2Desc: 'Users must provide accurate information, maintain confidentiality of their account, and use the platform professionally. Any attempt to circumvent anonymity protections, misrepresent credentials, or engage in discriminatory practices will result in immediate account termination.',
      termsSection3Title: 'Subscription & Payment Terms',
      termsSection3Desc: 'Employers access BlinD through subscription plans. All fees are clearly disclosed before purchase. Subscriptions auto-renew unless cancelled. Refunds are provided according to our refund policy. Candidates access the platform free of charge.',
      termsSection4Title: 'Limitation of Liability',
      termsSection4Desc: 'BlinD facilitates connections but does not guarantee employment outcomes. We are not responsible for hiring decisions, employment terms, or disputes between users. Our liability is limited to the amount paid for subscription services. Users agree to resolve disputes through binding arbitration.',
      cookiesSection1Title: 'What Are Cookies',
      cookiesSection1Desc: 'Cookies are small text files stored on your device that help us provide and improve our service. We use essential cookies for platform functionality, analytics cookies to understand usage patterns, and preference cookies to remember your settings.',
      cookiesSection2Title: 'Types of Cookies We Use',
      cookiesSection2Desc: 'Essential cookies enable core features like authentication and security. Analytics cookies help us understand how users interact with BlinD to improve the experience. Preference cookies remember your language and display settings. We do not use advertising or tracking cookies.',
      cookiesSection3Title: 'Managing Your Cookie Preferences',
      cookiesSection3Desc: 'You can control cookie settings through your browser preferences. Disabling essential cookies may affect platform functionality. You can opt out of analytics cookies while maintaining full access to BlinD features. Your cookie preferences are respected and stored securely.',
      dataSection1Title: 'GDPR Compliance',
      dataSection1Desc: 'BlinD fully complies with the European General Data Protection Regulation (GDPR). We process data lawfully, transparently, and for specific purposes. Users have rights to access, rectification, erasure, and data portability. We maintain detailed records of data processing activities.',
      dataSection2Title: 'PIPEDA Compliance',
      dataSection2Desc: 'We adhere to Canada\'s Personal Information Protection and Electronic Documents Act (PIPEDA). We obtain meaningful consent for data collection, limit data use to stated purposes, and implement appropriate security safeguards. Users can challenge our compliance at any time.',
      dataSection3Title: 'Loi 25 Compliance',
      dataSection3Desc: 'BlinD complies with Quebec\'s Law 25, modernizing privacy protection. We conduct privacy impact assessments, implement privacy by design principles, and report data breaches within required timeframes. We respect enhanced consent requirements and user rights specific to Quebec residents.',
      dataSection4Title: 'International Data Transfers',
      dataSection4Desc: 'When transferring data internationally, we use approved mechanisms such as Standard Contractual Clauses. We ensure adequate protection regardless of data location. Users are informed of data transfer practices and can object to transfers that don\'t meet protection standards.',
      employerTermsTitle: 'Employer Terms of Service',
      employerTermsSubtitle: 'Please review and accept the following terms to access BlinD as an employer',
      hiringFeeTitle: 'Hiring Fee Agreement',
      hiringFeeDesc: 'By using BlinD, you agree that any successful hire made through our platform is subject to a 20% placement fee based on the candidate\'s first-year annual salary. This fee is due within 30 days of the candidate\'s start date. The fee applies to all hires facilitated through BlinD, including direct offers and interviews arranged via our platform.',
      antiCircumventionTitle: 'Anti-Circumvention Agreement',
      antiCircumventionDesc: 'You agree not to circumvent the BlinD platform by hiring candidates outside of our system after being introduced through BlinD. This includes hiring candidates within 24 months of initial contact through our platform, regardless of whether the hire occurs through BlinD or external channels. Violation of this clause will result in immediate account termination and legal action to recover placement fees.',
      platformIntegrityTitle: 'Platform Integrity',
      platformIntegrityDesc: 'You agree to use BlinD exclusively for direct hiring purposes. Sharing candidate information with third-party recruiters, agencies, or other employers is strictly prohibited. All communications with candidates must occur through BlinD\'s secure messaging system until mutual identity reveal.',
      acceptTerms: 'I have read and agree to the Employer Terms of Service',
      acceptHiringFee: 'I understand and agree to the 20% placement fee for successful hires',
      acceptAntiCircumvention: 'I agree not to circumvent the platform and will honor the 24-month exclusivity period'
    },
    cta: {
      badge: 'Plateforme à accès limité',
      title: 'Prêt à transformer votre recherche de carrière?',
      subtitle: 'Rejoignez BlinD aujourd\'hui et découvrez des opportunités qui correspondent à votre expertise tout en maintenant un anonymat complet jusqu\'à ce que vous soyez prêt à révéler votre identité.',
      requestAccessNow: 'Demander l\'accès maintenant',
      noCreditCard: 'Aucune carte de crédit requise',
      manualApproval: 'Processus d\'approbation manuel',
      anonymous: '100% Anonyme'
    }
  },
  'fr-CA': {
    common: {
      loading: 'Chargement...',
      save: 'Enregistrer',
      cancel: 'Annuler',
      delete: 'Supprimer',
      edit: 'Modifier',
      close: 'Fermer',
      apply: 'Appliquer',
      clear: 'Effacer',
      search: 'Rechercher',
      filter: 'Filtrer',
      all: 'Tous',
      yes: 'Oui',
      no: 'Non',
      send: 'Envoyer',
      back: 'Retour',
      next: 'Suivant',
      submit: 'Soumettre',
      continue: 'Continuer',
      learnMore: 'En savoir plus',
      getStarted: 'Commencer'
    },
    nav: {
      feed: 'Fil',
      matches: 'Jumelages',
      messages: 'Messages',
      notifications: 'Notifications',
      profile: 'Profil',
      dashboard: 'Tableau de bord',
      candidates: 'Candidats',
      settings: 'Paramètres',
      features: 'Fonctionnalités',
      howItWorks: 'Comment ça marche',
      about: 'À propos',
      forCompanies: 'Pour les entreprises',
      forCandidates: 'Pour les candidats'
    },
    hero: {
      badge: 'Réseautage Professionnel Anonyme',
      title: 'Votre Évolution de Carrière Prochaine,',
      titleLine2: 'Sans Révéler Votre Identité',
      description: 'Connectez-vous avec des opportunités exceptionnelles d\'employeurs directs tout en maintenant un anonymat complet. Accédez à des rôles premium sélectionnés pour professionnels seniors.',
      requestAccess: 'Demander l\'Accès',
      learnMore: 'En savoir plus',
      feature1: '100% Anonyme',
      feature2: '8+ Ans d\'expérience',
      feature3: 'Curated par des experts'
    },
    accessRequest: {
      title: 'Choisissez votre rôle',
      subtitle: 'Sélectionnez comment vous souhaitez utiliser BlinD',
      qualificationTitle: 'Qualification',
      qualificationSubtitle: 'Parlez-nous de votre parcours professionnel',
      fullName: 'Nom complet',
      email: 'Adresse courriel',
      experience: 'Années d\'expérience',
      industry: 'Industrie',
      seniority: 'Niveau de séniorité',
      language: 'Préférence linguistique',
      location: 'Emplacement',
      linkedinUrl: 'Profil LinkedIn',
      confirmExperience: 'Je confirme avoir 8+ années d\'expérience professionnelle à un niveau senior',
      confirmDiscretion: 'Je comprends que mon identité restera anonyme jusqu\'à ce que je choisisse de la révéler',
      candidateTitle: 'Je suis un professionnel senior',
      candidateDesc: 'À la recherche de ma prochaine opportunité de carrière',
      candidateReq1: '8+ années d\'expérience professionnelle',
      candidateReq2: 'Poste de niveau senior ou exécutif',
      candidateReq3: 'Actuellement employé ou récemment en transition',
      employerTitle: 'Je suis un employeur',
      employerDesc: 'À la recherche de talents seniors',
      employerReq1: 'Autorité d\'embauche directe',
      employerReq2: 'Pas une agence de recrutement',
      employerReq3: 'Embauche de postes de niveau senior',
      applicationReceived: 'Demande reçue',
      reviewProcess: 'Processus de révision',
      reviewProcessDesc: 'Notre équipe examinera votre demande dans les 2-3 jours ouvrables',
      nextSteps: 'Prochaines étapes',
      nextStepsDesc: 'Si approuvé, vous recevrez vos identifiants d\'accès par courriel',
      questions: 'Questions?',
      questionsDesc: 'Contactez-nous à',
      returnHome: 'Retour à l\'accueil',
      successTitle: 'Merci pour votre demande!',
      successSubtitle: 'Nous avons reçu votre demande et l\'examinerons sous peu.',
      successCandidateMessage: 'En tant que candidat, vous aurez accès à des opportunités exclusives d\'employeurs vérifiés une fois approuvé.',
      successEmployerMessage: 'En tant qu\'employeur, vous pourrez accéder à notre bassin de professionnels seniors une fois vérifié.'
    },
    termsOfService: {
      stepLabel: 'Conditions d\'utilisation',
      title: 'Accord de conditions d\'utilisation',
      subtitle: 'Veuillez lire et accepter les conditions suivantes avant de continuer',
      feeStructureTitle: 'Structure des frais de la plateforme',
      feeStructureDesc: 'En utilisant la plateforme BlinD pour embaucher des candidats, vous acceptez que toutes les embauches réussies effectuées via cette plateforme soient soumises à des frais de placement. Ces frais garantissent la qualité et la durabilité de notre service.',
      feeHighlight: 'Des frais de placement de 20% s\'appliquent à toutes les embauches effectuées via la plateforme BlinD, calculés sur le salaire annuel de la première année du candidat.',
      antiCircumventionTitle: 'Politique anti-contournement',
      antiCircumventionDesc: 'Pour maintenir l\'équité et l\'intégrité de la plateforme, vous acceptez de ne pas contourner la plateforme en embauchant des candidats en dehors de BlinD après avoir été présenté via notre service. Cela inclut:',
      antiCircumventionPoint1: 'Contacter les candidats directement en dehors de la plateforme pour éviter les frais',
      antiCircumventionPoint2: 'Embaucher des candidats via d\'autres canaux après la présentation initiale via BlinD',
      antiCircumventionPoint3: 'Partager les informations des candidats avec des tiers pour faciliter l\'embauche hors plateforme',
      antiCircumventionWarning: 'La violation de cette politique peut entraîner la résiliation immédiate du compte et des poursuites judiciaires pour récupérer les frais.',
      paymentTermsTitle: 'Conditions de paiement',
      paymentTermsDesc: 'Les frais de placement de 20% sont dus dans les 30 jours suivant la date de début du candidat. Le paiement doit être effectué via les méthodes spécifiées dans votre accord d\'employeur. Les paiements en retard peuvent entraîner des frais supplémentaires et la suspension du compte.',
      complianceTitle: 'Conformité et droits d\'audit',
      complianceDesc: 'BlinD se réserve le droit d\'auditer les activités d\'embauche pour assurer la conformité avec ces conditions. Vous acceptez de fournir une documentation raisonnable sur demande pour vérifier que toutes les embauches présentées via BlinD sont correctement déclarées et les frais payés.',
      agreeFeeStructure: 'Je comprends et accepte la structure de frais de placement de 20% pour toutes les embauches effectuées via BlinD',
      agreeAntiCircumvention: 'Je comprends et accepte de ne pas contourner la plateforme et respecterai la période d\'exclusivité de 24 mois',
      agreePaymentTerms: 'Je comprends et accepte les conditions de paiement, y compris le délai de paiement de 30 jours',
      agreeCompliance: 'Je comprends et accepte les droits d\'audit de BlinD et fournirai la documentation nécessaire',
      finalAcknowledgment: 'En cochant toutes les cases ci-dessus, vous reconnaissez avoir lu, compris et accepté d\'être lié par ces conditions d\'utilisation. La violation de ces conditions peut entraîner la résiliation du compte et des conséquences juridiques.'
    },
    onboarding: {
      languageTitle: 'Sélectionnez votre langue préférée',
      languageSubtitle: 'Choisissez la langue pour votre expérience BlinD',
      english: 'English',
      englishDesc: 'All content in English',
      french: 'Français',
      frenchDesc: 'Tout le contenu en français',
      bilingual: 'Bilingue',
      bilingualDesc: 'Contenu dans les deux langues',
      locationTitle: 'Où êtes-vous situé?',
      locationSubtitle: 'Cela nous aide à vous montrer des opportunités pertinentes dans votre région',
      country: 'Pays/Région',
      province: 'Province',
      state: 'État',
      selectProvince: 'Sélectionnez votre province',
      selectState: 'Sélectionnez votre état'
    },
    opportunityFeed: {
      title: 'Fil d\'opportunités',
      newToday: 'Nouveaux aujourd\'hui',
      totalMatches: 'Jumelages totaux',
      exceptionalOnly: 'Exceptionnels seulement',
      location: 'Emplacement',
      industry: 'Industrie',
      roleType: 'Type de poste',
      analyzing: 'Analyse de l\'opportunité...',
      pass: 'Passer',
      interested: 'Intéressé',
      itsAMatch: 'C\'est un jumelage!',
      matchMessage: 'L\'employeur est également intéressé par votre profil. Vous pouvez maintenant commencer une conversation.',
      viewMatches: 'Voir les jumelages',
      keepExploring: 'Continuer l\'exploration',
      noOpportunities: 'Plus d\'opportunités',
      noOpportunitiesMessage: 'Revenez plus tard pour de nouvelles opportunités correspondant à votre profil.',
      adjustFilters: 'Ajuster les filtres',
      savedFilters: 'Filtres enregistrés',
      searchHistory: 'Historique de recherche'
    },
    matchManagement: {
      title: 'Gestion des jumelages',
      totalMatches: 'Jumelages totaux',
      activeConversations: 'Conversations actives',
      pendingReveals: 'Révélations en attente',
      scheduledMeetings: 'Rencontres planifiées',
      filterByStatus: 'Filtrer par statut',
      searchMatches: 'Rechercher des jumelages...',
      message: 'Message',
      requestReveal: 'Demander révélation',
      scheduleMeeting: 'Planifier rencontre',
      archive: 'Archiver',
      noMatches: 'Aucun jumelage',
      noMatchesMessage: 'Commencez à explorer les opportunités pour trouver votre jumelage parfait.',
      exploreOpportunities: 'Explorer les opportunités',
      bulkActions: 'Actions groupées'
    },
    filters: {
      saveFilter: 'Enregistrer le filtre',
      filterName: 'Nom du filtre',
      savedFilters: 'Filtres enregistrés',
      noSavedFilters: 'Aucun filtre enregistré',
      searchHistory: 'Historique de recherche',
      recentSearches: 'Recherches récentes',
      clearHistory: 'Effacer l\'historique',
      noSearchHistory: 'Aucun historique de recherche'
    },
    preview: {
      title: 'Galerie de professionnels seniors',
      subtitle: 'Aperçu des profils anonymes de talents seniors exceptionnels',
      searchPlaceholder: 'Rechercher par rôle, compétences ou industry...',
      allRoles: 'Tous les rôles',
      allIndustries: 'Toutes les industries',
      viewProfile: 'Voir le profil complet',
      requestAccess: 'Demander l\'accès pour se connecter',
      badge: 'Bassin de talents seniors - 8+ ans d\'expérience',
      mainTitle: 'Rencontrez nos professionnels seniors anonymes',
      mainSubtitle: 'Aperçu du calibre des talents seniors avec 8+ ans d\'expérience disponibles sur BlinD. Des cadres de direction aux directeurs de projet et gestionnaires seniors - tous les profils sont anonymes pour protéger la confidentialité des candidats tout en mettant en valeur leur expertise.',
      ctaTitle: 'Prêt à accéder à ce bassin de talents?',
      ctaSubtitle: 'Rejoignez BlinD pour vous connecter avec ces professionnels seniors exceptionnels et découvrir de nombreux autres candidats qualifiés avec 8+ ans d\'expérience dans toutes les industries et tous les rôles.',
      ctaButton: 'Demander l\'accès employeur',
      filterByRole: 'Filtrer par rôle',
      filterByIndustry: 'Filtrer par industrie',
      experience: 'Expérience',
      industries: 'Industries',
      professionalProfile: 'Profil professionnel',
      keySkills: 'Compétences clés',
      keyAchievements: 'Réalisations clés',
      more: 'de plus',
      availableOnMarket: 'Disponible sur le marché',
      openToOpportunities: 'Ouvert aux opportunités',
      showLess: 'Voir moins',
      viewDetails: 'Voir les détails',
      cSuiteExecutives: 'Cadres de direction',
      avgYearsExperience: 'Années d\'expérience moy.',
      avgMatchScore: 'Score de jumelage moy.',
      identityProtected: 'Identité protégée'
    },
    features: {
      title: 'Pourquoi choisir BlinD?',
      subtitle: 'Une plateforme collaborative conçue pour les professionnels seniors et les employeurs avant-gardistes',
      anonymity: 'Anonymat complet',
      anonymityDesc: 'Votre identité reste cachée jusqu\'à ce que vous choisissiez de la révéler. Pas de noms, pas de photos, pas de détails d\'entreprise.',
      exclusiveNetwork: 'Réseau exclusif curated',
      exclusiveNetworkDesc: 'Accès à des professionnels seniors vérifiés avec 8+ ans d\'expérience dans tous les secteurs, soigneusement curated par les experts de Groupe JM.',
      directEmployers: 'Connexions directes',
      directEmployersDesc: 'Connectez-vous directement avec les entreprises via notre plateforme. De vraies opportunités de vrais décideurs.',
      hiddenMarket: 'Accès au marché caché',
      hiddenMarketDesc: 'Découvrez des postes non annoncés et des opportunités exclusives via notre réseau curated.',
      verifiedProfiles: 'Profils vérifiés',
      verifiedProfilesDesc: 'Chaque candidat passe par un processus de vérification rigoureux pour assurer la qualité et la pertinence.',
      smartMatching: 'Jumelage intelligent',
      smartMatchingDesc: 'Le jumelage alimenté par l\'IA met en évidence votre expertise sans révéler qui vous êtes. Balayez les opportunités qui correspondent à vos critères.',
      controlReveals: 'Vous contrôlez les révélations',
      controlRevealsDesc: 'Décidez quand et à qui vous révélez votre identité. Chaque révélation nécessite un consentement explicite.'
    },
    hiddenMarketSection: {
      mainStat: '80%',
      mainTitle: 'Des opportunités pertinentes pour les profils seniors proviennent du marché caché de l\'emploi',
      mainSubtitle: 'Le marché caché représente la majorité des opportunités de qualité qui ne sont jamais publiées publiquement.',
      forCompanies: 'Pour les entreprises',
      companiesTitle: 'Accès direct aux talents seniors pré-vérifiés',
      companiesDesc: 'Connectez-vous directement avec des professionnels expérimentés dans tous les secteurs et postes via notre réseau exclusif curated.',
      companiesBenefit1: 'Tous les postes dans tous les secteurs (8+ ans d\'expérience)',
      companiesBenefit2: 'Accès aux talents seniors passifs curated par les experts de Groupe JM',
      companiesBenefit3: 'Profils vérifiés seulement - qualité assurée par notre équipe',
      companiesBenefit4: 'Publiez des postes de manière confidentielle sans alerter les équipes internes',
      whyDifferent: 'Pourquoi BlinD est différent:',
      exclusiveNetworkTitle: 'Réseau exclusif curated',
      exclusiveNetworkDesc: 'Professionnels seniors soigneusement sélectionnés et vérifiés par Groupe JM',
      rigorousVerification: 'Vérification rigoureuse',
      rigorousVerificationDesc: 'Chaque candidat passe la vérification pour assurer la qualité et la pertinence',
      directPassiveTalent: 'Accès aux talents passifs',
      directPassiveTalentDesc: 'Atteignez les meilleurs performeurs qui ne cherchent pas activement d\'emploi',
      viewSeniorProfessionals: 'Voir les professionnels seniors',
      forCandidates: 'Pour les candidats',
      candidatesTitle: 'Explorez les opportunités sans risque',
      candidatesDesc: 'Accédez à des opportunités exclusives du marché caché de l\'emploi tout en maintenant un anonymat complet. Parfait pour les professionnels expérimentés explorant leur prochaine étape.',
      candidatesBenefit1: 'Opportunités dans tous les secteurs pour les professionnels avec 8+ ans d\'expérience',
      candidatesBenefit2: 'Accès direct aux entreprises via notre plateforme',
      candidatesBenefit3: 'Explorez passivement pendant que vous êtes employé - personne ne le saura jamais',
      candidatesBenefit4: 'Vous contrôlez quand et comment vous révélez votre identité',
      yourAdvantages: 'Vos avantages:',
      anonymousExploration: 'Exploration 100% anonyme',
      anonymousExplorationDesc: 'Explorez les opportunités sans alerter votre employeur actuel ou équipe actuel',
      accessHiddenMarket: 'Accédez au marché caché',
      accessHiddenMarketDesc: '80% des opportunités de qualité ne sont jamais publiées publiquement - accédez-y ici',
      completeConfidentiality: 'Confidentialité complète',
      completeConfidentialityDesc: 'Pas de profil public, pas d\'activité LinkedIn, aucun risque pour votre poste actuel'
    },
    problem: {
      title: 'Le marché de l\'emploi traditionnel est brisé',
      subtitle: 'Les professionnels seniors méritent mieux que le spam, les risques de confidentialité et le temps perdu.',
      recruiterSpam: 'Spam de recruteurs',
      recruiterSpamDesc: 'Votre boîte de réception inondée d\'opportunités non pertinentes d\'agences qui ne comprennend pas votre expertise ou vos objectifs de carrière.',
      privacyConcerns: 'Préoccupations de confidentialité',
      privacyConcernsDesc: 'L\'employeur actuel découvre votre recherche d\'emploi, risquant votre poste et vos relations professionnelles avant que vous ne soyez prêt à bouger.',
      timeWasted: 'Temps perdu',
      timeWastedDesc: 'Des heures passées en appels avec des recruteurs qui ne peuvent pas tenir leurs promesses, pour découvrir que le rôle ne correspond pas à vos attentes.',
      cvFatigue: 'Fatigue de CV',
      cvFatigueDesc: 'Mise à jour et adaptation constantes des CV pour des rôles qui peuvent même ne pas exister ou correspondre à vos qualifications réelles.'
    },
    solution: {
      badge: 'La solution BlinD',
      title: 'Réseautage professionnel, réinventé',
      subtitle: 'Une plateforme premium conçue exclusiquement pour les professionnels seniors recherchant discrétion et qualité.',
      completeAnonymity: 'Anonymat complet',
      completeAnonymityDesc: 'Votre identité reste cachée jusqu\'à ce que vous choisissiez de la révéler. Pas de noms, pas de photos, pas de détails d\'entreprise.',
      curatedOpportunities: 'Opportunités sélectionnées',
      curatedOpportunitiesDesc: 'Seulement des rôles exceptionnels d\'employeurs directs vérifiés. Pas d\'agences, pas de spam, pas de perte de temps.',
      smartMatching: 'Jumelage intelligent',
      smartMatchingDesc: 'Les profils alimentés par l\'IA mettent en évidence votre expertise sans révéler qui vous êtes. Balayez les opportunités qui correspondent à vos critères.',
      controlReveals: 'Vous contrôlez les révélations',
      controlRevealsDesc: 'Décidez quand et à qui vous révélez votre identité. Chaque révélation nécessite un consentement explicite.'
    },
    talent: {
      badge: 'Pour les talents',
      title: 'Votre carrière, vos conditions',
      subtitle: 'Vous avez construit 8+ ans d\'expertise. Vous méritez des opportunités qui correspondent à votre calibre, présentées avec la discrétion que vous exigez.',
      stayAnonymous: 'Restez anonyme',
      stayAnonymousDesc: 'Parcourez les opportunités sans que votre employeur actuel ne le sache',
      premiumRoles: 'Rôles premium',
      premiumRolesDesc: 'Accédez à des postes de direction et de leadership non annoncés publiquement',
      directContact: 'Contact direct',
      directContactDesc: 'Connectez-vous directement avec les gestionnaires d\'embauche, sautez les recruteurs',
      youDecide: 'Vous décidez',
      youDecideDesc: 'Contrôlez quand et comment vous engager, avec un anonymat complet jusqu\'à ce que vous choisissiez de révéler votre identité',
      requestTalentAccess: 'Demander l\'accès talent',
      identityProtected: 'Identité protégée'
    },
    employer: {
      badge: 'Pour les employeurs',
      title: 'Embauchez des talents de direction,',
      titleLine2: 'Discrètement et efficacement',
      subtitle: 'Accédez à un bassin sélectionné de cadres supérieurs et dirigeants avec 8+ ans d\'expérience. Voyez exactement ce qui compte: titres, compétences et expertise—sans le bruit.',
      executiveCandidatePool: 'Bassin de candidats de direction',
      matches: 'Jumelages',
      experience: 'Expérience',
      whyBlinDBetter: 'Pourquoi BlinD surpasse le recrutement traditionnel',
      headhunters: 'Méthodes traditionnelles',
      headhuntersProblem: 'Portée limitée',
      headhuntersSolution: 'Bassin de talents élargi',
      jobBoards: 'Sites d\'emploi publics',
      jobBoardsProblem: 'Bassin de candidats large',
      jobBoardsSolution: 'Professionnels seniors curated',
      linkedinRecruiter: 'Approche directe',
      linkedinProblem: 'Processus intensif en temps',
      linkedinSolution: 'Jumelage d\'intérêt mutuel',
      passiveTalent: 'Talents passifs',
      passiveTalentDesc: 'Accédez à des professionnels seniors qui ne cherchent pas activement d\'emploi',
      structuredProfiles: 'Profils structurés',
      structuredProfilesDesc: 'Profils générés par l\'IA révélant l\'expertise sans CV traditionnels',
      fastMatching: 'Jumelage rapide',
      fastMatchingDesc: 'Interface de balayage pour une révision efficace des candidats',
      directHiring: 'Connexions directes',
      directHiringDesc: 'Connexions rationalisées via notre plateforme',
      requestEmployerAccess: 'Demander l\'accès employeur',
      previewWhat: 'Aperçu de ce que les employeurs voient'
    },
    howItWorks: {
      badge: 'Processus simple',
      title: 'Comment fonctionne BlinD',
      subtitle: 'From anonymous profile to successful match in four simple steps.',
      step1Title: 'Demander l\'accès',
      step1Desc: 'Soumettez votre demande avec les qualifications de base. Nous examinons manuellement chaque candidature pour assurer la qualité.',
      step2Title: 'Créer un profil anonyme',
      step2Desc: 'Répondez à des questions spécifiques à l\'industrie. Notre IA génère un profil convaincant qui met en valeur votre expertise sans révéler votre identité.',
      step3Title: 'Parcourir et jumeler',
      step3Desc: 'Balayez les opportunités ou candidats sélectionnés. Lorsque les deux parties expriment leur intérêt, c\'est un jumelage.',
      step4Title: 'Révélation contrôlée',
      step4Desc: 'Décidez quand révéler votre identité. Chaque révélation nécessite un consentement explicite.'
    },
    about: {
      title: 'Notre histoire',
      subtitle: 'Construire l\'avenir du recrutement senior',
      originsTitle: 'Nos origines',
      originsDesc: 'Groupe JM connecte les entreprises avec les meilleurs talents depuis des années. Grâce à cette expérience, nous avons identifié une opportunité de mieux servir les professionnels seniors et les employeurs.',
      breakingPointTitle: 'Notre vision',
      breakingPointDesc1: 'Nous avons reconnu que les professionnels seniors ont besoin d\'une plateforme qui priorise l\'anonymat et la discrétion tandis que les employeurs ont besoin d\'accès à des talents passifs qualifiés.',
      breakingPointDesc2: 'Nous nous sommes demandé: Comment pouvons-nous créer une solution complémentaire qui enrichit l\'écosystème de recrutement?',
      missionTitle: 'Notre mission aujourd\'hui',
      missionDesc1: 'BlinD a été créé pour compléter les approches de recrutement existantes avec un réseau exclusif et curated de professionnels seniors.',
      missionDesc2: 'Nous nous associons avec les employeurs, les professionnels et les acteurs de l\'industrie pour favoriser des connexions anonymes et diversifiées pour tous les rôles seniors.',
      forCandidatesTitle: 'Pour les candidats',
      forCandidatesDesc: 'Explorez les opportunités avec un anonymat complet et le contrôle de votre parcours de carrière',
      forCompaniesTitle: 'Pour les entreprises',
      forCompaniesDesc: 'Accédez à des talents seniors exclusifs via notre réseau curated et plateforme rationalisée',
      ourPromiseTitle: 'Notre promesse',
      ourPromiseDesc: 'Des connexions significatives qui complètent vos stratégies existantes et stimulent une croissance réelle'
    },
    trust: {
      badge: 'Confiance et sécurité',
      title: 'Votre confidentialité est notre priorité',
      subtitle: 'Sécurité et conformité de niveau entreprise pour protéger votre identité professionnelle.',
      dataProtection: 'Protection des données',
      dataProtectionDesc: 'Conformité totale avec les réglementations canadiennes et américaines sur la protection des données',
      encryptedCommunication: 'Communication cryptée',
      encryptedCommunicationDesc: 'Cryptage de bout en bout pour tous les messages et données de profil',
      manualReview: 'Examen manuel',
      manualReviewDesc: 'Chaque révélation d\'identité est approuvée manuellement par notre équipe',
      certifiedCompliant: 'Certifié et conforme',
      soc2: 'SOC 2 Type II',
      gdpr: 'Conforme RGPD',
      iso: 'ISO 27001',
      pipeda: 'Certifié LPRPDE',
      loi25: 'Conforme Loi 25'
    },
    contact: {
      badge: 'Contactez-nous',
      title: 'Nous contacter',
      subtitle: 'Vous avez des questions? Nous sommes là pour vous aider. Contactez notre équipe.',
      emailUs: 'Envoyez-nous un courriel',
      emailDesc: 'contact@blindrecruit.com',
      liveChat: 'Chat en direct',
      liveChatDesc: 'Disponible lun-ven, 9h-17h HNE',
      callUs: 'Appelez-nous',
      callUsDesc: '514-562-6813',
      yourName: 'Votre nom',
      emailAddress: 'Adresse courriel',
      subject: 'Sujet',
      subjectPlaceholder: 'Comment pouvons-nous vous aider?',
      message: 'Message',
      messagePlaceholder: 'Parlez-nous de votre demande...',
      sendMessage: 'Envoyer le message',
      successMessage: 'Merci de nous avoir contactés! Nous vous répondrons dans les 24 heures.'
    },
    footer: {
      tagline: 'Réseautage professionnel anonyme pour les talents seniors et les employeurs directs par Groupe JM. Votre prochaine opportunité de carrière, sans révéler votre identité.',
      product: 'Produit',
      company: 'Entreprise',
      legal: 'Légal',
      features: 'Fonctionnalités',
      howItWorks: 'Comment ça marche',
      forTalent: 'Pour les talents',
      forEmployers: 'Pour les employeurs',
      aboutUs: 'À propos',
      contact: 'Contact',
      careers: 'Carrières',
      blog: 'Blog',
      privacyPolicy: 'Politique de confidentialité',
      termsOfService: 'Conditions d\'utilisation',
      cookiePolicy: 'Politique de cookies',
      dataProtection: 'Protection des données',
      allRightsReserved: 'BlinD. Tous droits réservés.',
      location: 'Canada et États-Unis',
      compliant: 'Conforme RGPD, LPRPDE et Loi 25'
    },
    profiles: {
      titles: {
        ceo: 'Chef de la direction',
        cfo: 'Directrice Financière',
        itDirector: 'Directeur des technologies de l\'information',
        projectDirector: 'Directeur de projet',
        seniorDeveloper: 'Développeur logiciel senior',
        chiefAccountant: 'Chef Comptable',
        hrDirector: 'Directrice des ressources humaines',
        realEstateDirector: 'Directrice immobilier',
        vpConstruction: 'Vice-Président Construction'
      },
      industries: {
        technology: 'Technologie',
        saas: 'SaaS',
        finance: 'Finance',
        fintech: 'FinTech',
        healthcare: 'Santé',
        construction: 'Construction',
        realEstate: 'Immobilier',
        ecommerce: 'Commerce électronique',
        manufacturing: 'Fabrication',
        humanResources: 'Ressources humaines',
        investment: 'Investissement',
        infrastructure: 'Infrastructure'
      },
      skills: {
        strategicPlanning: 'Planification stratégique',
        plManagement: 'Gestion P&L',
        boardRelations: 'Relations avec le conseil',
        ma: 'Fusions et acquisitions',
        fundraising: 'Levée de fonds',
        financialStrategy: 'Stratégie financière',
        ipoExperience: 'Expérience IPO',
        riskManagement: 'Gestion des risques',
        fpa: 'Planification et analyse financière',
        treasury: 'Trésorerie',
        itInfrastructure: 'Infrastructure TI',
        cybersecurity: 'Cybersécurité',
        cloudMigration: 'Migration cloud',
        teamLeadership: 'Leadership d\'équipe',
        vendorManagement: 'Gestion des fournisseurs',
        projectManagement: 'Gestion de projet',
        budgetControl: 'Contrôle budgétaire',
        stakeholderManagement: 'Gestion des parties prenantes',
        riskMitigation: 'Atténuation des risques',
        qualityAssurance: 'Assurance qualité',
        fullStackDevelopment: 'Développement full-stack',
        systemArchitecture: 'Architecture système',
        codeReview: 'Révision de code',
        mentoring: 'Mentorat',
        agileScrum: 'Agile/Scrum',
        financialReporting: 'Rapports financiers',
        ifrsGaap: 'IFRS/PCGR',
        auditManagement: 'Gestion d\'audit',
        taxCompliance: 'Conformité fiscale',
        erpSystems: 'Systèmes ERP',
        talentAcquisition: 'Acquisition de talents',
        organizationalDevelopment: 'Développement organisationnel',
        employeeRelations: 'Relations avec les employés',
        compensationStrategy: 'Stratégie de rémunération',
        changeManagement: 'Gestion du changement',
        portfolioManagement: 'Gestion de portefeuille',
        assetValuation: 'Évaluation d\'actifs',
        leaseNegotiation: 'Négociation de baux',
        marketAnalysis: 'Analyse de marché',
        investmentStrategy: 'Stratégie d\'investissement',
        constructionManagement: 'Gestion de construction',
        safetyCompliance: 'Conformité en matière de sécurité',
        contractNegotiation: 'Négociation de contrats',
        costEstimation: 'Estimation des coûts'
      },
      achievements: {
        ceo1: 'Fait passer l\'entreprise de 5M$ à 50M$ de revenus récurrents annuels',
        ceo2: 'Dirigé une série B réussie (30M$)',
        ceo3: 'Constitué une équipe de 20 à 200+ personnes',
        cfo1: 'Dirigé le processus d\'IPO (évaluation de 500M$)',
        cfo2: 'Réduit les coûts de 30%',
        cfo3: 'Mis en place des contrôles financiers',
        it1: 'Migré les systèmes d\'entreprise vers le cloud (disponibilité de 99,9%)',
        it2: 'Réduit les coûts TI de 35%',
        it3: 'Dirigé une équipe de 25+ professionnels TI',
        project1: 'Livré des projets de 200M$+ dans les délais',
        project2: 'Géré 15+ projets simultanés',
        project3: 'Atteint un taux de satisfaction client de 98%',
        dev1: 'Conçu une plateforme desservant 5M+ d\'utilisateurs',
        dev2: 'Réduit le temps de chargement des pages de 60%',
        dev3: 'Encadré 10+ développeurs juniors',
        accountant1: 'Rationalisé la clôture de fin de mois de 40%',
        accountant2: 'Dirigé des audits externes réussis (opinions sans réserve)',
        accountant3: 'Mis en place des systèmes de rapports automatisés',
        hr1: 'Réduit le roulement de 45%',
        hr2: 'Construit la fonction RH à partir de zéro',
        hr3: 'Mis en place un système de gestion de la performance',
        realEstate1: 'Géré un portefeuille immobilier de 500M$+',
        realEstate2: 'Négocié des transactions économiant 10M$+ par an',
        realEstate3: 'Atteint un ROI moyen de 15%',
        construction1: 'Supervisé plus de 1G$ en projets de construction',
        construction2: 'Maintenu un dossier zéro incident de sécurité',
        construction3: 'Dirigé des équipes de 100+ travailleurs'
      },
      descriptions: {
        ceo: 'Leader visionnaire avec un historique éprouvé dans la mise à l\'échelle d\'entreprises technologiques. Expert dans la navigation de dynamiques complexes de conseil d\'administration et l\'obtention de financement stratégique. Reconnu pour la constitution d\'équipes hautement performantes et la conduite d\'une croissance durable grâce à une prise de décision basée sur les données.',
        cfo: 'Cadre financier stratégique avec une expertise approfondie des marchés des capitaux et des opérations de sociétés publiques. Naviguée avec succès plusieurs funding rounds et le processus d\'IPO. Compétent dans la construction d\'une infrastructure financière robuste tout en maintenant l\'efficacité opérationnelle.',
        itDirector: 'Leader TI axé sur les résultats, spécialisé dans la transformation numérique et la modernisation des infrastructures. Expert en équilibre des exigences de sécurité avec l\'agilité commerciale. Capacité éprouvée à gérer des relations complexes avec les fournisseurs et à livrer des projets dans les délais et sous budget.',
        projectDirector: 'Leader de projet accompli avec une vaste expérience dans la gestion d\'initiatives à grande échelle de la conception à l\'achèvement. Expert en coordination d\'équipes interfonctionnelles et le maintien de contrôles budgétaires stricts. Reconnu pour une communication exceptionnelle avec les parties prenantes et une gestion proactive des risques.',
        seniorDeveloper: 'Professionnel technique hautement qualifié avec une expertise approfondie dans la construction d\'applications Web évolutives. Fervent défenseur du code propre et des meilleures pratiques. Passionné par le mentorat des développeurs juniors et la promotion d\'une culture d\'ingénierie collaborative.',
        chiefAccountant: 'Professionnel comptable soucieux du détail avec une connaissance approfondie des réglementations financières et des normes de rapports. Expert dans la gestion d\'audits complexes et l\'assurance de la conformité réglementaire. Compétent dans l\'exploitation de la technologie pour améliorer les processus comptables et la précision.',
        hrDirector: 'Leader RH stratégique axé sur la construction de cultures axées sur les personnes qui génèrent des résultats commerciaux. Expert dans la conception de structures de rémunération et de programmes de développement des talents. Historique éprouvé dans la gestion du changement organisationnel et la promotion de l\'engagement des employés.',
        realEstateDirector: 'Professionnel immobilier chevronné avec une vaste expérience dans la gestion de propriétés commerciales et résidentielles. Expert in l\'identification d\'opportunités d\'investissement à haute valeur et la négociation de conditions favorables. Solides compétences analytiques avec une compréhension approfondie de la dynamique du marché.',
        vpConstruction: 'Cadre de construction expérimenté avec une connaissance approfondie des codes du bâtiment, des réglementations de sécurité et des méthodes de livraison de projets. Expert en gestion d\'opérations de construction à grande échelle et l\'assurance des normes de qualité. Solides compétences en leadership avec un accent sur la culture de sécurité et l\'excellence opérationnelle.'
      },
      availability: {
        openToOpportunities: 'Ouvert aux opportunités',
        selective: 'Sélectif'
      },
      companyScale: {
        employees200Plus: '200+ employés',
        employees500Plus: '500+ employés',
        employees300to500: '300-500 employés',
        employees150to200: '150-200 employés',
        employees100to150: '100-150 employés',
        employees250to300: '250-300 employés',
        employees400Plus: '400+ employés',
        employees50to100: '50-100 employés'
      }
    },
    profileCarousel: {
      sectionTitle: 'Découvrez des talents exceptionnels',
      sectionSubtitle: 'Explorez les profils des professionnels seniors avec expérience vérifiée',
      verifiedBadge: 'Tous les profils sont vérifiés et anonymisés',
      aiMatching: 'Jumelage IA',
      keySkills: 'Compétences clés',
      achievements: 'Réalisations',
      availableOnMarket: 'Disponible sur le marché',
      openToOpportunities: 'Ouvert aux opportunités',
      experience: 'Expérience',
      employees: 'employés',
      profiles: {
        cfo: {
          title: 'Directrice Financière',
          experience: '12+ ans d\'expérience',
          teamSize: '500+ employés',
          industries: ['Finance', 'FinTech'],
          description: 'Exécutive financière stratégique avec une expertise approfondie des marchés des capitaux et des opérations de sociétés publiques. Naviguée avec succès plusieurs funding rounds et le processus d\'IPO.',
          skills: ['Stratégie financière', 'Expérience IPO', 'Gestion des risques', 'Planification et analyse financière', 'Trésorerie'],
          achievements: [
            'Dirigé le processus d\'IPO (évaluation de 500M$)',
            'Réduit les coûts de 30%',
            'Mis en place des contrôles financiers'
          ]
        },
        vpConstruction: {
          title: 'Vice-Président Construction',
          experience: '16+ ans d\'expérience',
          teamSize: '500+ employés',
          industries: ['Construction', 'Infrastructure'],
          description: 'Exécutive de construction expérimentée avec une connaissance approfondie des codes du bâtiment, des réglementations de sécurité et des méthodes de livraison de projets. Expert en gestion d\'opérations de construction à grande échelle.',
          skills: ['Gestion de construction', 'Conformité en matière de sécurité', 'Négociation de contrats', 'Leadership d\'équipe', 'Estimation des coûts'],
          achievements: [
            'Supervisé plus de 1G$ en projets de construction',
            'Maintenu un dossier zéro incident de sécurité',
            'Dirigé des équipes de 100+ travailleurs'
          ]
        },
        itDirector: {
          title: 'Directeur des Technologies de l\'Information',
          experience: '10+ ans d\'expérience',
          teamSize: '300-500 employés',
          industries: ['Technologie', 'Santé'],
          description: 'Leader TI axé sur les résultats, spécialisé dans la transformation numérique et la modernisation des infrastructures. Expert en équilibre des exigences de sécurité avec l\'agilité commerciale.',
          skills: ['Infrastructure TI', 'Cybersécurité', 'Migration cloud', 'Leadership d\'équipe', 'Gestion des fournisseurs'],
          achievements: [
            'Migré les systèmes d\'entreprise vers le cloud (disponibilité de 99,9%)',
            'Réduit les coûts TI de 35%',
            'Dirigé une équipe de 25+ professionnels TI'
          ]
        }
      }
    },
    collaborativePhilosophy: {
      badge: 'Notre philosophie collaborative',
      title: 'Enrichir l\'écosystème de recrutement',
      subtitle: 'Chez BlinD et Groupe JM, nous croyons en un écosystème de recrutement collaboratif',
      description: 'Un réseau exclusif curated par nos experts qui complète les méthodes existantes. En partenariat avec les employeurs, les professionnels et les acteurs de l\'industrie, nous favorisons des connexions anonymes et diversifiées pour tous les rôles seniors.',
      principle1Title: 'Approche complémentaire',
      principle1Desc: 'BlinD enrichit vos stratégies de recrutement existantes plutôt que de les remplacer. Nous fournissons un canal supplémentaire pour accéder aux talents seniors passifs.',
      principle2Title: 'Curation experte',
      principle2Desc: 'Chaque profil est soigneusement vérifié et curated par les experts de Groupe JM pour assurer la qualité et la pertinence pour les postes de niveau senior.',
      principle3Title: 'Focus partenariat',
      principle3Desc: 'Nous travaillons en collaboration avec les employeurs et les professionnels pour créer des jumelages optimaux qui profitent à tous dans l\'écosystème.',
      principle4Title: 'Excellence inclusive',
      principle4Desc: 'Notre plateforme favorise la diversité et l\'inclusion tout en maintenant les normes les plus élevées pour l\'expérience professionnelle senior.'
    },
    complementarity: {
      badge: 'Complémentarité et partenariats',
      title: 'Comment BlinD complète votre processus',
      subtitle: 'BlinD by Groupe JM s\'intègre harmonieusement avec vos stratégies de recrutement existantes',
      forEmployers: 'Pour les employeurs',
      employerBenefit1Title: 'Canal de talents supplémentaire',
      employerBenefit1Desc: 'Accès gratuit à un bassin curated de professionnels seniors passifs qui complète vos méthodes de recrutement existantes',
      employerBenefit2Title: 'Intégration harmonieuse',
      employerBenefit2Desc: 'Fonctionne aux côtés de vos outils et stratégies actuels sans perturber les processus établis',
      employerBenefit3Title: 'Partenariat expert',
      employerBenefit3Desc: 'Collaborez avec Groupe JM pour des jumelages optimaux tout en maintenant vos relations de recrutement existantes',
      forCandidates: 'Pour les candidats',
      candidateBenefit1Title: 'Exploration complémentaire',
      candidateBenefit1Desc: 'Explorez les opportunités de manière anonyme tout en maintenant toutes vos relations professionnelles et réseaux existants',
      candidateBenefit2Title: 'Opportunités curated',
      candidateBenefit2Desc: 'Accès à des opportunités exclusives curated par les experts de Groupe JM qui complètent les marchés de l\'emploi publics',
      candidateBenefit3Title: 'Contrôle total',
      candidateBenefit3Desc: 'Vous décidez quand et comment vous engager, avec un anonymat complet jusqu\'à ce que vous choisissiez de révéler votre identité'
    },
    legal: {
      badge: 'Legal Information',
      title: 'Legal & Compliance',
      subtitle: 'Our commitment to transparency, privacy, and legal compliance',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      cookiePolicy: 'Cookie Policy',
      dataProtection: 'Data Protection',
      lastUpdated: 'Last updated: January 15, 2026',
      privacySection1Title: 'Information We Collect',
      privacySection1Desc: 'BlinD collects minimal personal information necessary to provide our anonymous professional networking service. We collect professional background data, anonymized career information, and communication preferences. All data is encrypted and stored securely in compliance with GDPR, PIPEDA, and Loi 25 regulations.',
      privacySection2Title: 'How We Use Your Information',
      privacySection2Desc: 'Your information is used exclusively to facilitate anonymous job matching between senior professionals and direct employers. We use AI-powered algorithms to match profiles without revealing identities. Your data is never sold to third parties or used for purposes beyond our core service.',
      privacySection3Title: 'Data Security & Anonymity',
      privacySection3Desc: 'We employ industry-leading encryption and security measures to protect your identity. All profiles are anonymized before being shown to employers. Personal identifying information is stored separately from professional profiles and only revealed with your explicit consent after a mutual match.',
      privacySection4Title: 'Your Rights & Control',
      privacySection4Desc: 'You have complete control over your data. You can access, modify, or delete your information at any time. You control when and to whom you reveal your identity. We comply with all data subject rights under GDPR, PIPEDA, and Loi 25, including the right to be forgotten.',
      termsSection1Title: 'Platform Access & Eligibility',
      termsSection1Desc: 'BlinD is available to senior professionals with 8+ years of experience and direct hiring companies. Recruitment agencies and intermediaries are not permitted. Access is granted through a verification process to ensure platform integrity and user safety.',
      termsSection2Title: 'User Conduct & Responsibilities',
      termsSection2Desc: 'Users must provide accurate information, maintain confidentiality of their account, and use the platform professionally. Any attempt to circumvent anonymity protections, misrepresent credentials, or engage in discriminatory practices will result in immediate account termination.',
      termsSection3Title: 'Subscription & Payment Terms',
      termsSection3Desc: 'Employers access BlinD through subscription plans. All fees are clearly disclosed before purchase. Subscriptions auto-renew unless cancelled. Refunds are provided according to our refund policy. Candidates access the platform free of charge.',
      termsSection4Title: 'Limitation of Liability',
      termsSection4Desc: 'BlinD facilitates connections but does not guarantee employment outcomes. We are not responsible for hiring decisions, employment terms, or disputes between users. Our liability is limited to the amount paid for subscription services. Users agree to resolve disputes through binding arbitration.',
      cookiesSection1Title: 'What Are Cookies',
      cookiesSection1Desc: 'Cookies are small text files stored on your device that help us provide and improve our service. We use essential cookies for platform functionality, analytics cookies to understand usage patterns, and preference cookies to remember your settings.',
      cookiesSection2Title: 'Types of Cookies We Use',
      cookiesSection2Desc: 'Essential cookies enable core features like authentication and security. Analytics cookies help us understand how users interact with BlinD to improve the experience. Preference cookies remember your language and display settings. We do not use advertising or tracking cookies.',
      cookiesSection3Title: 'Managing Your Cookie Preferences',
      cookiesSection3Desc: 'You can control cookie settings through your browser preferences. Disabling essential cookies may affect platform functionality. You can opt out of analytics cookies while maintaining full access to BlinD features. Your cookie preferences are respected and stored securely.',
      dataSection1Title: 'GDPR Compliance',
      dataSection1Desc: 'BlinD fully complies with the European General Data Protection Regulation (GDPR). We process data lawfully, transparently, and for specific purposes. Users have rights to access, rectification, erasure, and data portability. We maintain detailed records of data processing activities.',
      dataSection2Title: 'PIPEDA Compliance',
      dataSection2Desc: 'We adhere to Canada\'s Personal Information Protection and Electronic Documents Act (PIPEDA). We obtain meaningful consent for data collection, limit data use to stated purposes, and implement appropriate security safeguards. Users can challenge our compliance at any time.',
      dataSection3Title: 'Loi 25 Compliance',
      dataSection3Desc: 'BlinD complies with Quebec\'s Law 25, modernizing privacy protection. We conduct privacy impact assessments, implement privacy by design principles, and report data breaches within required timeframes. We respect enhanced consent requirements and user rights specific to Quebec residents.',
      dataSection4Title: 'International Data Transfers',
      dataSection4Desc: 'When transferring data internationally, we use approved mechanisms such as Standard Contractual Clauses. We ensure adequate protection regardless of data location. Users are informed of data transfer practices and can object to transfers that don\'t meet protection standards.',
      employerTermsTitle: 'Employer Terms of Service',
      employerTermsSubtitle: 'Please review and accept the following terms to access BlinD as an employer',
      hiringFeeTitle: 'Hiring Fee Agreement',
      hiringFeeDesc: 'By using BlinD, you agree that any successful hire made through our platform is subject to a 20% placement fee based on the candidate\'s first-year annual salary. This fee is due within 30 days of the candidate\'s start date. The fee applies to all hires facilitated through BlinD, including direct offers and interviews arranged via our platform.',
      antiCircumventionTitle: 'Anti-Circumvention Agreement',
      antiCircumventionDesc: 'You agree not to circumvent the BlinD platform by hiring candidates outside of our system after being introduced through BlinD. This includes hiring candidates within 24 months of initial contact through our platform, regardless of whether the hire occurs through BlinD or external channels. Violation of this clause will result in immediate account termination and legal action to recover placement fees.',
      platformIntegrityTitle: 'Platform Integrity',
      platformIntegrityDesc: 'You agree to use BlinD exclusively for direct hiring purposes. Sharing candidate information with third-party recruiters, agencies, or other employers is strictly prohibited. All communications with candidates must occur through BlinD\'s secure messaging system until mutual identity reveal.',
      acceptTerms: 'I have read and agree to the Employer Terms of Service',
      acceptHiringFee: 'Je comprends et accepte les frais de placement de 20% pour les embauches réussies',
      acceptAntiCircumvention: 'J\'accepte de ne pas contourner la plateforme et respecterai la période d\'exclusivité de 24 mois'
    }
  }
};